import React from 'react'

const OrderCancelDetails = () => {
  return (
    <div>OrderCancelDetails</div>
  )
}

export default OrderCancelDetails